import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

export default {
  path: '/interview/',
  name: 'interview',
  meta: {
    auth: true
  },
  redirect: {
    name: 'interview-index'
  },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'apply',
      name: `${pre}apply`,
      component: _import('interview/apply'),
      meta: {
        title: '提交申请'
      }
    },
    {
      path: 'applylist',
      name: `${pre}applylist`,
      component: _import('interview/applylist'),
      meta: {
        title: '申请列表'
      }
    },
    {
      path: 'my',
      name: `${pre}my`,
      component: _import('interview/my'),
      meta: {
        title: '我的申请'
      }
    },
    {
      path: 'review',
      name: `${pre}review`,
      component: _import('interview/review'),
      meta: {
        title: '申请审批'
      }
    }, {
      path: 'task',
      name: `${pre}task`,
      component: _import('interview/task'),
      meta: {
        title: '任务认领'
      }
    }, {
      path: 'calendar',
      name: `${pre}calendar`,
      component: _import('interview/calendar'),
      meta: {
        title: '日程安排'
      }
    }
  ])('interview-')
}
